import { DrugInteractionContentModel } from './drugInteractionContentModel';

export class DrugToFoodAlcoholInteractionModel {
  public selectedIngredientId: number;
  public selectedIngredientName: string;
  public foodAlcoholId: number;
  public foodAlcoholName: string;
  public interactionTypeId: number;
  public consumerDecscription: string;
  public professionalDecscription: string;
  public drugToFoodAlcoholInteractionContent: Array<DrugInteractionContentModel>;
}